import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

function Header() {
  const portalUrl = window.ThemeSettings.portal_url || '';
  const logoutUrl = window.ThemeSettings.logout_url.replace(/&amp;/g, '&') || '';

  return (
    <header>
      <Container className="py-4 mb-4">
        <Row className="align-items-center">
          <Col>
            <div className="logo" />
          </Col>
          <Col className="text-end">
            {
              portalUrl &&
              <Button target="_blank" className="mx-2 portal-btn" href={portalUrl}>
                Портал задач
              </Button>
            }
            <Button
              href={logoutUrl}
              variant="outline-primary"
            >
              Вийти
            </Button>
          </Col>
        </Row>
        {
          portalUrl &&
          <Row className="portal-btn-mobile">
            <Col className="text-end">
              <Button target="_blank" href={portalUrl}>
                Портал задач
              </Button>
            </Col>
          </Row>
        }
      </Container>
    </header>
  );
}

export default Header;
